import { useQuery } from '@tanstack/react-query';

import { BaseError } from 'helpers/BaseError';

import alternateKeys from 'hooks/alternates/_queryKeys';
import useGetCurrentMessageContent from 'hooks/message-content/useGetCurrentMessageContent';

import { VariantWithLabel } from 'models/variant.model';

// services
import API from '../../services/api';

const getVariants = async (
    messageContentId: string,
): Promise<VariantWithLabel[]> => {
    const { data } = await API.fetchVariantsByMessageContentId(
        messageContentId,
    );
    return data;
};

export default function useVariantsByMessageContentIdQuery(formulaId: number) {
    const { currentMessageContentId } = useGetCurrentMessageContent(formulaId);

    return useQuery<VariantWithLabel[], BaseError>({
        queryKey: alternateKeys.getVariantsByMessageContentId(
            currentMessageContentId as string,
        ),
        queryFn: () => getVariants(currentMessageContentId as string),
        enabled: !!currentMessageContentId,
        staleTime: 2 * 60 * 60 * 1000, // 2 hours
    });
}
